var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 48 48",
    height: "48px",
    id: "Layer_4",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#241F20",
    points: "11.21,2.707 0,2.707 0,6.75 8.166,6.75 15.59,34 15.614,33.993 15.614,34 48,34 48,30 18.646,30     "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.771,
    cy: 40,
    fill: "#241F20",
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.614,
    cy: 40,
    fill: "#241F20",
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.099,21.438c0.678,0,1.313-0.185,1.86-0.502v6.085h4.576h1.511h6.438h2.441h3.644v-6.085   c0.549,0.317,1.183,0.502,1.861,0.502c2.056,0,3.722-1.667,3.722-3.722c0-2.055-1.666-3.722-3.722-3.722   c-0.679,0-1.312,0.185-1.861,0.502V8.412h-6.085c0.318-0.548,0.503-1.183,0.503-1.861c0-2.056-1.667-3.722-3.722-3.722   c-2.057,0-3.723,1.667-3.723,3.722c0,0.678,0.185,1.313,0.503,1.861h-6.086v6.085c-0.547-0.317-1.182-0.502-1.86-0.502   c-2.056,0-3.722,1.667-3.722,3.722C18.377,19.772,20.043,21.438,22.099,21.438z",
    fill: "#241F20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddon);
export default __webpack_public_path__ + "static/media/addon.ab07104ff9159380e79c9e9ad8e5f1ed.svg";
export { ForwardRef as ReactComponent };